import {
  Box,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";
import React, { useState } from "react";

import ScheduleCalendar from "../components/ScheduleCalendar";

const Schedule = () => {
  // Get current month and year for default values
  const currentDate = new Date();
  const [month, setMonth] = useState(currentDate.getMonth() + 1); // JavaScript months are 0-indexed
  const [year, setYear] = useState(currentDate.getFullYear());

  // Month names for dropdown
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Generate array of years (current year - 1 to current year + 3)
  const years = [];
  for (
    let i = currentDate.getFullYear() - 1;
    i <= currentDate.getFullYear() + 3;
    i++
  ) {
    years.push(i);
  }

  // Handle month change
  const handleMonthChange = (event) => {
    setMonth(event.target.value);
  };

  // Handle year change
  const handleYearChange = (event) => {
    setYear(event.target.value);
  };

  return (
    <Container>
      <Paper elevation={3} sx={{ mt: 4, p: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3, gap: 2 }}>
          <FormControl sx={{ minWidth: 120 }}>
            <InputLabel id="month-select-label">Month</InputLabel>
            <Select
              labelId="month-select-label"
              id="month-select"
              value={month}
              label="Month"
              onChange={handleMonthChange}
            >
              {monthNames.map((name, index) => (
                <MenuItem key={name} value={index + 1}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 100 }}>
            <InputLabel id="year-select-label">Year</InputLabel>
            <Select
              labelId="year-select-label"
              id="year-select"
              value={year}
              label="Year"
              onChange={handleYearChange}
            >
              {years.map((yearValue) => (
                <MenuItem key={yearValue} value={yearValue}>
                  {yearValue}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <ScheduleCalendar month={month} year={year} />
      </Paper>
    </Container>
  );
};

export default Schedule;
